// import styled from 'styled-components';
import styled from "@emotion/styled";

export const WheelCanvasStyle = styled.canvas`
  width: 98%;
  height: 98%;
`;
